import Axios from 'axios'
import React,{useState, useEffect} from 'react'
import { withRouter } from 'react-router'
import { getUser } from '../../../../actions/session'
import { ACCOUNT_PRODUCT_LISTING } from '../../../../config/rest_endpoints'
import { RC_LOAD_LOGIN } from '../../../routers/RouteConstants'

import CustomLoader from '../../../common/loader'
import CustomModal from '../../../common/modal'
import { Notifications } from '../../../common/notification'
import CreateBilling from './components/createBilling'
import UpdateBilling from './components/updateBiling'

const ProductTable = (props) => {
    const {id} = props
    const [tableItem, setTableItem] = useState([])
    const [userInfo] = useState(getUser())
    const [isGetting, setIsGetting] = useState(false)
    const [isCreate, setIsCreate] = useState(false)
    const [isUpdate, setIsUpdate] = useState(false)
    const [prevValue, setPreviousValue] = useState({})


    useEffect(()=> {
        getProductList()
    },[])

    const openCreateModal = () => {
        setIsCreate(true)
    }

    const closeCreateModal = () => {
        setIsCreate(false)
    }

    const openUpdateModal = (data) => {
        console.log(`data`, data)
        setIsUpdate(true)
        setPreviousValue(data)
    }

    const closeUpdateModal = () => {
        setIsUpdate(false)
    }

    const getProductList = () => {
        setIsGetting(true)
        var headers = { "Authorization": "Bearer " + userInfo.token };
        Axios.get(`${ACCOUNT_PRODUCT_LISTING}/${id}`, { headers }).then(res => {
            if (res) {
                console.log(`res`, res)
                const resp = res.data.data
                setTableItem(resp)
                setIsGetting(false)

            }
        }).catch(err => {
            const alert = err.response
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                props.history.push(RC_LOAD_LOGIN)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            setIsGetting(false)
        })
    }

    const renderProductList = () => {
        const nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (!tableItem) {
            return nullData
        }
        else {
            return tableItem.map((row, idx) => {
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'center'}}>{row.category}</td>
                        <td style={{textAlign:'center'}}>{row.description}</td>
                        <td style={{textAlign:'center'}}>{row.method}</td>
                        <td style={{textAlign:'center'}}>{row.amount}</td>
                        <td style={{textAlign:'center'}}>{row.units}</td>
                        <td style={{textAlign:'center'}}>{row.frequency}</td>
                        {<td style={{textAlign:'center'}}>{row.createDate}</td>}
                        <td style={{textAlign:'center'}}>{row.active ? <span class="badge badge-success">True</span> : <span class="badge badge-danger">False</span>}</td>
                        {/*<td>{row.endDate}</td>*/}
                        {/*<td>{row.forBack}</td>*/}
                        {/*<td>{row.generateInvoice}</td>*/}
                        <td style={{textAlign:'center',fontSize:'20px'}}><i className="text-primary fa fa-edit mr-2" onClick={openUpdateModal.bind(this,row)} ></i></td>
                    </tr>
                )
            })
        }
    }

    const createBilling = {
        details: {
            info: "Create Billing",
            msg: <CreateBilling userId={id} listRefresh={getProductList} close={closeCreateModal}  />
        },
        confirmBtn: { label: "Update", action: '' },
        crossBtn: { action: closeCreateModal },
        cancelBtn: { label: "Cancel", action: closeCreateModal }
    }

    const updateBilling = {
        details: {
            info: "Update Product",
            msg: <UpdateBilling userId={id} previousValue={prevValue}  listRefresh={getProductList} close={closeUpdateModal} />
        },
        confirmBtn: { label: "Update", action: '' },
        crossBtn: { action: closeUpdateModal },
        cancelBtn: { label: "Cancel", action: closeUpdateModal }
    }

    return (
        <div>
             <CustomModal
                    visibility={isCreate}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    modalSize={'large'}
                    details={createBilling.details}
                    showBtns={false}
                    cancelBtn={createBilling.cancelBtn}
                    crossBtn={createBilling.crossBtn}
                />
                <CustomModal
                    visibility={isUpdate}
                    modalType={"success"}
                    modalHeader={'success'}
                    modalSize={'large'}
                    details={updateBilling.details}
                    showBtns={false}
                    cancelBtn={updateBilling.cancelBtn}
                    crossBtn={updateBilling.crossBtn}
                />
            <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body border-left-dark-alpha border-right-dark-alpha ">
                <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer mt-2">
                    <div className=" border-0 datatable-header">
                        <div id="DataTables_Table_0_filter" className="dataTables_filter">

                            <div class="input-group">
                                <input type="text" class="form-control border-right-0" placeholder="Filter Product" />

                                <span class="input-group-append">
                                    <button class="btn search-button" type="button"><i class="fa fa-search"></i></button>
                                </span>
                            </div>
                        </div>
                        <div className="header-elements">
                            <button type="submit" className="main-button btn btn-success btn-sm ml-3 float-right" onClick={openCreateModal} >Create Billing<i className="fas fa-plus ml-2"></i></button>
                        </div>
                    </div>
                    <div className="mt-1 datatable-scroll " style={{overflowX: 'auto' }}>
                        <table style={{border:'1px solid #ddd',borderCollapse:'collapse'}} className="table table-striped  no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                            <thead>
                                <tr className="stickeyHeader">
                                    <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Category</th>
                                    <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Description</th>
                                    <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Method</th>
                                    <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Amount</th>
                                    <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Units</th>
                                    <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Frequency</th>
                                    {<th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Create Date</th>}
                                    <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Active</th>
                                    {/*<th>End Date</th>*/}
                                    {/*<th>For/Back</th>*/}
                                    {/*<th>Generate Invoice</th>*/}
                                    <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isGetting ? <CustomLoader /> : renderProductList()}
                            </tbody>
                        </table>
                    </div>
                    <div className="datatable-footer mt-1">
                        <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(ProductTable)